import React from "react";
import { useSiteContent } from "@/lib/siteContent";

export const Gallery = () => {
  const { content } = useSiteContent();
  const items = content.gallery_items || [];
  if (items.length === 0) return null;
  return (
    <section id="gallery" className="py-24 lg:py-32 bg-[#FDFBF7] relative">
      <div className="max-w-7xl mx-auto px-6 lg:px-10">
        <div className="max-w-3xl mb-12">
          <div className="text-[11px] uppercase tracking-[0.3em] text-[#CBA358] font-semibold">
            {content.gallery_eyebrow}
          </div>
          <h2 className="font-display text-4xl lg:text-5xl mt-4 text-[#0A2342] leading-[1.05] text-balance">
            {content.gallery_headline}
          </h2>
          {content.gallery_description && (
            <p className="mt-5 text-[#5C636A] leading-relaxed max-w-2xl">
              {content.gallery_description}
            </p>
          )}
        </div>

        <div
          className="grid gap-3 sm:gap-4"
          style={{
            gridTemplateColumns: "repeat(auto-fit, minmax(220px, 1fr))",
          }}
        >
          {items.map((it, i) => (
            <figure
              key={it.id || i}
              data-testid={`gallery-item-${i}`}
              className={`group relative overflow-hidden bg-[#0A2342] ${
                i % 6 === 0 ? "sm:row-span-2 sm:col-span-2 aspect-[4/3]" : "aspect-[4/5]"
              }`}
            >
              <img
                src={it.image}
                alt={it.caption || `Gallery ${i + 1}`}
                loading="lazy"
                className="w-full h-full object-cover transition-transform duration-700 group-hover:scale-105"
              />
              {it.caption && (
                <figcaption className="absolute inset-x-0 bottom-0 bg-gradient-to-t from-[#0A2342] via-[#0A2342]/70 to-transparent p-4 text-[#FDFBF7] text-sm">
                  {it.caption}
                </figcaption>
              )}
            </figure>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Gallery;
